import { render } from "./ButtonArrowCarouselPrevious.vue?vue&type=template&id=b1ce83ae&ts=true"
import script from "./ButtonArrowCarouselPrevious.vue?vue&type=script&lang=ts"
export * from "./ButtonArrowCarouselPrevious.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__